import { render, staticRenderFns } from "./webAITest.vue?vue&type=template&id=798fe28a&scoped=true&"
import script from "./webAITest.vue?vue&type=script&lang=js&"
export * from "./webAITest.vue?vue&type=script&lang=js&"
import style0 from "./webAITest.vue?vue&type=style&index=0&id=798fe28a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798fe28a",
  null
  
)

export default component.exports